import PreferenceRow from './PreferenceRow';

export default PreferenceRow;
